<template>
  <PrimaryHeader
      :logo="
      $q.screen.xs
        ? theme().novatedBrand?.logo?.mobile
        : theme().novatedBrand?.logo?.colour
    "
      :org-contact-email="theme().novatedBrand?.support?.email"
      :org-contact-phone="theme().novatedBrand?.support?.phone"
      :profile-name="$auth.isAuthenticated ? $auth.user.name : undefined"
      :profile-email="$auth.isAuthenticated ? $auth.user.email : undefined"
      :can-see-approvals="canSeeApprovals"
      :approvals="pendingApprovals.length"
      :tabs="tabs"
      :alert="!isProfileSetupComplete ? 1 : 0"
      :logged-out="!$auth.isAuthenticated"
      :is-mobile="$q.screen.xs"
      @logout="$router.push({ name: $RouteNames.logout })"
      @logIn="$router.push({ name: $RouteNames.login })"
      :can-clear-application="canClearApplication"
      :clearing-application="clearingApplication"
      :can-edit-profile="canEditProfile"
      :is-profile-setup-complete="isProfileSetupComplete"
      :profile-setup-complete-percentage="profileSetupCompletePercentage"
      :create-options="createOptions"
      @create="createAction"
      @click:menu="toggleMenu"
      @open:profile-page="openProfilePage"
      @open:profile-setup="openProfileStepper"
      @clear:application="clearApplication"
  />
</template>

<script>
import { getEnv } from 'ecx.saigon.ui.common';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import getUserPermissions from '@/utils/user-permissions';
import UserProfile from '../../widgets/user-profile';
import UserProfileStepper from '../../widgets/user-profile-stepper';
import { profileCompleteGuard } from '@/utils/profile-complete-guard';
import NewQuoteLeaseSelector from '@/components/organism/new-quote-lease-selector';
import resolveLocalRoute from '@/utils/resolve-local-route';

export default {
  name: 'HeaderWidget',
  data() {
    return {
      canClearApplication: false
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      primaryMenuOpen: (state) => state.ui.primaryMenuOpen,
      application: (state) => state.application.application,
      approvalsLoading: (state) => state.hr.approvalsLoading,
      clearingApplication: (state) => state.application.clearingApplication,
      hasLeases: (state) => state.lease.hasLeases
    }),
    ...mapGetters(['canCreateQuote', 'allowEndOfLifeQuote']),
    ...mapGetters('application', ['applicationComplete']),
    ...mapGetters('user', [
      'theme',
      'isProfileSetupComplete',
      'profileSetupCompletePercentage',
      'canEditProfile'
    ]),
    ...mapGetters('hr', ['pendingApprovals']),
    ...mapGetters('lease', ['nearExpirationRegos']),
    canSeeApprovals() {
      return getUserPermissions()[this.$Constants.PERMISSIONS.HR_APPROVAL];
    },
    tabs() {
      const inLifeTabs = this.hasLeases ? this.$Constants.IN_LIFE_TABS : [];
      return [...this.$Constants.COMMON_TABS, ...inLifeTabs];
    },
    createOptions() {
      let options = [];
      if (this.hasLeases) {
        options.push(this.$Constants.IN_LIFE_CREATE_OPTIONS.CLAIM);
      }
      if (this.canCreateQuote) {
        options.push(this.$Constants.IN_LIFE_CREATE_OPTIONS.QUOTE);
      }
      return options;
    }
  },
  methods: {
    ...mapActions('application', ['clearApplicationRequest']),
    ...mapMutations('ui', ['setState']),
    toggleMenu() {
      this.setState(['primaryMenuOpen', !this.primaryMenuOpen]);
    },
    async createQuote() {
      if (!profileCompleteGuard(this)) return;

      const env = await getEnv();

      if (this.allowEndOfLifeQuote) {
        this.$q
            .dialog({
              component: NewQuoteLeaseSelector,
              nearExpirationRegos: this.nearExpirationRegos
            })
            .onOk(async ({ leaseId }) => {
              window.location = resolveLocalRoute(
                  `${env.VUE_APP_QUOTE_ROUTE}${
                      leaseId ? `/calculator?leaseId=${leaseId}` : ''
                  }`
              );
            });
      } else {
        return (window.location = env.VUE_APP_QUOTE_ROUTE);
      }
    },
    openProfilePage() {
      this.SAIFullScreenDialog({
        parent: this,
        child: UserProfile
      });
    },
    openProfileStepper() {
      this.SAIFullScreenDialog({
        parent: this,
        noRouteDismiss: true,
        displayHideAction: false,
        child: UserProfileStepper
      });
    },
    async clearApplication() {
      await this.clearApplicationRequest();
      if (this.$router.currentRoute.name !== this.$RouteNames.dashboard) {
        await this.$router.push({ name: this.$RouteNames.dashboard });
        this.$router.go(0);
      }
    },
    createAction(key) {
      const options = this.$Constants.IN_LIFE_CREATE_OPTIONS;
      switch (key) {
        case options.CLAIM.key:
          if (this.$route.name !== this.$RouteNames.claimsNew) {
            return this.$router.push({
              name: this.$RouteNames.claimsNew
            });
          }
          break;
        case options.QUOTE.key:
          this.createQuote();
          break;
      }
    }
  },
  async mounted() {
    const env = await getEnv();
    this.canClearApplication = env.VUE_APP_CAN_CLEAR_APPLICATION;
  },
  components: {
    PrimaryHeader: () => import('../../components/organism/primary-header')
  }
};
</script>
